import {
  formatAppointmentTime,
  formatDateKey,
  formatWeekdayShort,
} from "./date";

export type SlotLike = {
  id: string;
  dateTime: string;
  timeZone: string;
  locationId: string | null;
};

export function formatSlotTime(slot: SlotLike): string {
  return formatAppointmentTime(slot.dateTime, slot.timeZone);
}

export function getSlotDateDisplay(slot: SlotLike): string {
  return formatWeekdayShort(slot.dateTime);
}

export function groupSlotsByDate<T extends SlotLike>(slots: T[]) {
  return Object.values(groupSlotsByDateKey(slots)).map((slotList) => ({
    date: getSlotDateDisplay(slotList[0]),
    slots: slotList,
  }));
}

/**
 * Group slots by YYYY-MM-DD key (for admin/booking flows).
 */
export function groupSlotsByDateKey<T extends SlotLike>(
  slots: T[]
): Record<string, T[]> {
  const groups: Record<string, T[]> = {};
  for (const slot of slots) {
    const key = formatDateKey(slot.dateTime);
    (groups[key] ??= []).push(slot);
  }
  for (const k of Object.keys(groups)) {
    groups[k].sort((a, b) => a.dateTime.localeCompare(b.dateTime));
  }
  return groups;
}

export function findNextAvailableDate(dates: string[]): string | undefined {
  const today = formatDateKey(new Date());
  const future = dates.filter((d) => d >= today).sort();
  return future[0];
}
